import { Component, Injector, OnInit } from '@angular/core';
import { EmailSenderService } from 'tnx-admin-service/app-settings/email-sender/services';
import { ComponentContextService, CrudFormData, DataFormBase, EventData, FormSchemaBase, FormState, PermissionBase, PopupSize, ResponseResult, TableSchema, TextControlSchema } from 'tnx-shared';

@Component({
    selector: 'email-sender',
    templateUrl: './email-sender.component.html',
    styleUrls: ['./email-sender.component.scss'],
    providers: [ComponentContextService],
})
export class EmailSenderComponent extends DataFormBase implements OnInit {
    submitting = false;
    showDetailForm = false;
    testEmailSenderSetting: any;
    testEmailSenderModel: CrudFormData;
    showPassword = false;
    private _testEmailSenderSetting: any = {
        popupHeader: 'Gửi email test',
        popupSize: new PopupSize({
            width: 900,
            height: 750
        })
    };

    private _testEmailSenderModel: CrudFormData = {
        componentSubs: [],
        data: {
            basePermission: PermissionBase.EDIT
        },
        submitting: false
    };

    constructor(
        private _emailSenderService: EmailSenderService,
        _injector: Injector
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._emailSenderService;
        this.model.formState = FormState.EDIT;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'server',
                label: 'Server SMTP (smtp.gmail.com, smtp.office365.com...)',
                required: true,
                mdWidth: 6,
            }),
            new TextControlSchema({
                field: 'port',
                label: 'Cổng (587, 465...)',
                dataFormat: 'number',
                required: true,
                min: 1,
                mdWidth: 6
            }),
            new TableSchema({
                label: 'Danh sách email',
                fullLabel: 'Danh sách email',
                field: 'account',
                mdWidth: 12,
                rowTemplate: [
                    new TextControlSchema({
                        label: 'Email',
                        fullLabel: 'Email',
                        field: 'emailFrom',
                        required: true,
                        dataFormat: 'email'
                    }),
                    new TextControlSchema({
                        label: 'Mật khẩu',
                        fullLabel: 'Mật khẩu',
                        field: 'emailPassword',
                        required: true,
                        dataFormat: 'password',
                        onChanged: (eventData: EventData) => {
                            console.log(eventData);
                        }
                    }),
                ]
            }),
        ];
    }

    async getObjectDetail(): Promise<ResponseResult> {
        return this._emailSenderService.getEmailSenderSetting();
    }

    async onFormInitialized(formEvent: EventData) {
        console.log(this.model.data);
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    onBeforeSave() {
        // trước khi lưu
    }

    customSave(evt) {
        this.submitting = true;
        console.log('save', this.model.data);
        this._emailSenderService.saveEmailSetting(this.model.data).then(rs => {
            this._notifierService.showSuccess('Lưu thiết lập thành công');
            this.submitting = false;
        }).catch(err => {
            console.error(err);
            this._notifierService.showWarning('Có lỗi xảy ra, vui lòng liên hệ quản trị để biết thêm chi tiết');
            this.submitting = false;
        });
    }

    refresh() {
        this._notifierService.showConfirm('Bạn có chắc chắn muốn làm mới dữ liệu? Lưu ý: Các thay đổi chưa được lưu sẽ bị mất!').then(rss => {
            if (rss) {
                this.submitting = true;
                this._emailSenderService.getEmailSenderSetting().then(rs => {
                    this.model.data = rs.data;
                    this._notifierService.showSuccess('Làm mới thành công');
                    this.submitting = false;
                }).catch(err => {
                    this._notifierService.showWarning('Có lỗi xảy ra, vui lòng liên hệ quản trị để biết thêm chi tiết');
                    this.submitting = false;
                });
            }
        });
    }

    customHandleCancel(evt) {
        this.showDetailForm = false;
    }

    sendTestEmail() {
        this.testEmailSenderSetting = this._commonService.cloneObject(this._testEmailSenderSetting);
        this.testEmailSenderModel = this._commonService.cloneObject(this._testEmailSenderModel);
        this.showDetailForm = true;
    }

    toggleHiddenPassword() {
        this.showPassword = !this.showPassword;
        this.formControls['account'].rowTemplate.find(x => x.field == 'emailPassword').dataFormat = this.showPassword ? 'text' : 'password';
    }
}
